import { Injectable } from '@angular/core';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';
import { Platform } from '@ionic/angular';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StatusBarService {
  isDarkMode: boolean;
  darkModeSource = new BehaviorSubject<boolean>(null);
  currentDarkModeSource = this.darkModeSource.asObservable();
  setAppDarkMode: (darkMode: string) => void;

  constructor(
    private statusBar: StatusBar,
    private platform: Platform,
  ) { }

  setForDarkColorPage() {
    if (this.platform.is('cordova')) {
      this.statusBar.overlaysWebView(true);
      this.statusBar.styleLightContent();
    }
  }

  setForLightColorPage() {
    if (this.platform.is('cordova')) {
      this.statusBar.overlaysWebView(true);
      this.statusBar.styleDefault();
    }
  }

  setForColorPageWithHeader(pageColorHex: string, isDarkPage: boolean) {
    if (this.platform.is('cordova')) {
      this.statusBar.overlaysWebView(false);
      this.statusBar.backgroundColorByHexString(pageColorHex);
      if (isDarkPage) {
        this.statusBar.styleLightContent();
      } else {
        this.statusBar.styleDefault();
      }
    }
  }

  setForWhitePage() {
    if (this.platform.is('cordova')) {
      this.statusBar.overlaysWebView(false);
      if (this.isDarkMode) {
        this.statusBar.backgroundColorByHexString('#1E1E1E');
        this.statusBar.styleLightContent();
      } else {
        this.statusBar.backgroundColorByName('white');
        this.statusBar.styleDefault();
      }
    }
  }

}
